import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { onLoadingFail, onLoadingStart, onLoadingSuccess } from '../../userFarmSlice';
import { createSelector } from 'reselect';
import { pick } from '../../../util/pick';

const importOrthophotoTaskProperties = ['task_id'];

const getImportOrthophotoTask = (task) => {
  return pick(task, importOrthophotoTaskProperties);
};

const upsertOneImportOrthophotoTask = (state, { payload: task }) => {
  importOrthophotoTaskAdapter.upsertOne(state, getImportOrthophotoTask(task));
};
const upsertManyImportOrthophotoTask = (state, { payload: tasks }) => {
  importOrthophotoTaskAdapter.upsertMany(
    state,
    tasks.map((task) => getImportOrthophotoTask(task)),
  );
  onLoadingSuccess(state);
};
const setAllImportOrthophotoTask = (state, { payload: tasks }) => {
  importOrthophotoTaskAdapter.setAll(
    state,
    tasks.map((task) => getImportOrthophotoTask(task)),
  );
  onLoadingSuccess(state);
};

const importOrthophotoTaskAdapter = createEntityAdapter({
  selectId: (importOrthophotoTask) => importOrthophotoTask.task_id,
});

const importOrthophotoTaskSlice = createSlice({
  name: 'importOrthophotoTaskReducer',
  initialState: importOrthophotoTaskAdapter.getInitialState({
    loading: false,
    error: undefined,
    task_id: undefined,
    loaded: false,
  }),
  reducers: {
    onLoadingImportOrthophotoTaskStart: onLoadingStart,
    onLoadingImportOrthophotoTaskFail: onLoadingFail,
    getImportOrthophotoTasksSuccess: upsertManyImportOrthophotoTask,
    getAllImportOrthophotoTasksSuccess: setAllImportOrthophotoTask,
    postImportOrthophotoTaskSuccess: upsertOneImportOrthophotoTask,
    editImportOrthophotoTaskSuccess: upsertOneImportOrthophotoTask,
    deleteImportOrthophotoTaskSuccess: importOrthophotoTaskAdapter.removeOne,
  },
});

export const {
  getImportOrthophotoTasksSuccess,
  getAllImportOrthophotoTasksSuccess,
  postImportOrthophotoTaskSuccess,
  editImportOrthophotoTaskSuccess,
  onLoadingImportOrthophotoTaskStart,
  onLoadingImportOrthophotoTaskFail,
  deleteImportOrthophotoTaskSuccess,
} = importOrthophotoTaskSlice.actions;
export default importOrthophotoTaskSlice.reducer;

export const importOrthophotoTaskReducerSelector = (state) =>
  state.entitiesReducer[importOrthophotoTaskSlice.name];

const importOrthophotoTaskSelectors = importOrthophotoTaskAdapter.getSelectors(
  (state) => state.entitiesReducer[importOrthophotoTaskSlice.name],
);

export const importOrthophotoTaskEntitiesSelector = importOrthophotoTaskSelectors.selectEntities;

export const importOrthophotoTaskStatusSelector = createSelector(
  [importOrthophotoTaskReducerSelector],
  ({ loading, error, loaded }) => {
    return { loading, error, loaded };
  },
);
